import { render, staticRenderFns } from "./ExportLayoutSettingsView.vue?vue&type=template&id=3c004e80&scoped=true"
import script from "./ExportLayoutSettingsView.ts?vue&type=script&lang=ts&external"
export * from "./ExportLayoutSettingsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c004e80",
  null
  
)

export default component.exports